import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { SVGIcon2 } from "../../components/common/SVGIconV2";
import { CrossActivity } from "./loader";

const WIDTH_TRANSITION_VALUE = 1480;

const CollapsableCrossActivityComponent = ({ active }) => {
  const [collapse, setCollapse] = useState(false);

  useEffect(() => {
    const clientHeight = Math.max(
      document.documentElement.clientWidth,
      window.innerHeight || 0
    );

    setCollapse(clientHeight < WIDTH_TRANSITION_VALUE);
  }, []);

  return (
    <>
      {active && collapse && (
        <a className="aChelpLink circleIcon">
          <SVGIcon2 iconName="default-logo" />
        </a>
      )}
      {(!collapse || !active) && <CrossActivity />}
    </>
  );
};

CollapsableCrossActivityComponent.propTypes = {
  active: PropTypes.bool
};

export const CollapsableCrossActivity = React.memo(
  CollapsableCrossActivityComponent
);
